@if (boelsUser().debtor?.name) {
  <span class="account-indicator-label">{{ getInitials() }}</span>
} @else {
  <fa-icon class="account-indicator-not-found" [icon]="faUser"></fa-icon>
}
